/**
 * @file EasyDeploy 首页
 * @author wanzhongyun
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'moment/locale/zh-cn';

import EasyDeploy from './EasyDeploy';
import './style.less';
// import PageNotFound from '../404/PageNotFound';
// import '../404/style.less';


moment.locale('zh-cn');

ReactDOM.render(<EasyDeploy />, document.getElementById('root'));
// ReactDOM.render(<PageNotFound />, document.getElementById('root'));